import React from 'react'
import { Dropdown, DropdownItemProps, Modal, StrictModalProps } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

import RejectionMessage, { IRejectionMessage } from './RejectionMessage'

export interface IRejectionDialogProps extends StrictModalProps {
  item: string
  rejections: IRejectionMessage[]
  warnings: IRejectionMessage[]
  renderActions?: JSX.Element
  showMultiple?: boolean
  title?: string
  description?: string
  onLinkClick?: () => void

  reasons?: DropdownItemProps[]
  onReasonChange?: (reason: string) => void
}

export type RejectionDialogProps = IRejectionDialogProps

const RejectionDialog: React.FC<RejectionDialogProps> = props => {
  const { t } = useTranslation()
  const { renderActions, rejections, warnings, item, reasons, onReasonChange, onLinkClick, showMultiple, title, description, ...rest } =
    props

  const defaultTitle = t('rejection_dialog.base_title', { item })
  const defaultDescription = t('rejection_dialog.base_description', { item })

  return (
    <Modal size='small' closeOnEscape closeOnDimmerClick dimmer {...rest}>
      <Modal.Header>{title || defaultTitle}</Modal.Header>
      <Modal.Content>
        <p>{rejections.length > 0 ? t('rejection_dialog.base_warning_message') : description || defaultDescription}</p>
        {rejections.map(rejection => (
          <RejectionMessage key={rejection.type} error rejection={rejection} onLinkClick={onLinkClick} showMultiple={showMultiple} />
        ))}
        {warnings.map(warning => (
          <RejectionMessage key={warning.type} rejection={warning} onLinkClick={onLinkClick} showMultiple={showMultiple} />
        ))}
        {reasons && reasons.length > 0 && (
          <React.Fragment>
            {t('rejection_dialog.reason_text', { item })}
            <Dropdown
              placeholder={t('rejection_dialog.reason_placeholder')}
              data-testid='rejectiondialog-reason-dropdown'
              name='reason'
              fluid
              selection
              onChange={(_, props) => onReasonChange && onReasonChange(props.value as string)}
              options={reasons}
            />
          </React.Fragment>
        )}
      </Modal.Content>
      <Modal.Actions>{renderActions}</Modal.Actions>
    </Modal>
  )
}

export default React.memo(RejectionDialog)
